import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import VueTouch from 'vue-touch';
import Vuelidate from 'vuelidate';
import 'vue-material-design-icons/styles.css';
import ArrowDown from 'vue-material-design-icons/ArrowDown.vue';
import CheckIcon from 'vue-material-design-icons/Check.vue';
import AlertIcon from 'vue-material-design-icons/Alert.vue';
import PlusIcon from 'vue-material-design-icons/Plus.vue';
import CloseIcon from 'vue-material-design-icons/Close.vue';
import ChevronRight from 'vue-material-design-icons/ChevronRight.vue';
import ChevronLeft from 'vue-material-design-icons/ChevronLeft.vue';
import FacebookIcon from 'vue-material-design-icons/Facebook.vue';
import LinkedinIcon from 'vue-material-design-icons/Linkedin.vue';
import './firebase';

Vue.use(Vuelidate);
Vue.use(VueTouch);
VueTouch.config.swipe = {
  direction: 'horizontal'
};
Vue.component('check-icon', CheckIcon);
Vue.component('arrow-down', ArrowDown);
Vue.component('alert-icon', AlertIcon);
Vue.component('plus-icon', PlusIcon);
Vue.component('close-icon', CloseIcon);
Vue.component('chevron-right-icon', ChevronRight);
Vue.component('chevron-left-icon', ChevronLeft);
Vue.component('facebook-icon', FacebookIcon);
Vue.component('linkedin-icon', LinkedinIcon);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
